import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './Nav.module.css';

const LINKS = [
  { label: 'About Brian', href: '#about' },
  { label: 'Media', href: '#personality' },
  { label: 'Influencer', href: '#influencer' },
  { label: 'Contact', href: '#contact' }
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <div className={styles.nav}>
      <button
        type="button"
        className={open ? `${styles.toggle} ${styles.open}` : styles.toggle}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label="Menu"
      >
        <span />
        <span />
        <span />
      </button>
      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className={styles.backdrop}
              onClick={close}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
            />
            <motion.nav
              className={styles.menu}
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.15 }}
            >
              {LINKS.map((link) => (
                <a key={link.href} href={link.href} className={styles.link} onClick={close}>
                  {link.label}
                </a>
              ))}
            </motion.nav>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
